import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { fetchEmployerPageEventContent } from "../../../redux/actions/company_action";
import EmployerFeaturedMedia from "../EmployerFeaturedMedia/EmployerFeaturedMedia";
import EmployHeroBeyondJob from "../EmployerHeroBeyondJob/EmployHeroBeyondJob";
import EmployerHeroCarousel from "../EmployerHeroCarousel/EmployHeroCarousel";
import EmployerHeroSolution from "../EmployerHeroSolution/EmployHeroSolution";
import EmployerHeroTagline from "../EmployerHeroTagline/EmployHeroTagline";
import EmployerHireBetterEvent from "../EmployerHireBetterNew/EmployerHireBetterEvent";
import EmployerHireBetterNew from "../EmployerHireBetterNew/EmployerHireBetterNew";
import EmployerInternships from "../EmployerInternships/EmployerInternships";
import EmployerKnowMore from "../EmployerKnowMore/EmployerKnowMore";
import EmployerLandingAggregator from "../EmployerLandingAggregator/EmployerLandingAggregator";
import EmployerLandingCompanies from "../EmployerLandingCompanies/EmployerLandingCompanies";
import EmployerLandingContactUs from "../EmployerLandingContactUs/EmployerLandingContactUs";
import EmployerLandingContactUsDialog from "../EmployerLandingContactUsDialog/EmployerLandingContactUsDialog";
import EmployerLandingPlatform from "../EmployerLandingPlatform/EmployerLandingPlatform";
import EmployerLandingStatistics from "../EmployerLandingStatistics/EmployerLandingStatistics";
import EmployerLandingViewProductDialog from "../EmployerLandingViewProductDialog/EmployerLandingViewProductDialog";
import EmployerLandingWorkCultureReport from "../EmployerLandingWorkCultureReport/EmployerLandingWorkCultureReport";
import EmployerTestimonial from "../EmployerTestimonial/EmployerTestimonial";
import { Wrapper } from "./styles";

const IS_MALAYSIA = process.env.NEXT_PUBLIC_JSW_GEOLOCATION === "my";

// A missing bound leaves that end of the window open
function isWithinEventWindow(startDate, endDate) {
  const now = Date.now();
  const start = startDate ? new Date(startDate).getTime() : null;
  const end = endDate ? new Date(endDate).getTime() : null;

  if (start && now < start) return false;
  if (end && now > end) return false;

  return Boolean(startDate || endDate);
}

function EmployerLanding() {
  const dispatch = useDispatch();
  const [isEvent, setIsEvent] = useState(false);

  useEffect(() => {
    let isActive = true;

    async function fetchEventWindow() {
      const eventContent = await dispatch(fetchEmployerPageEventContent());
      if (!isActive) return;

      const isRegionEligible = IS_MALAYSIA || Boolean(eventContent?.syncSg);
      const inWindow = isWithinEventWindow(
        eventContent?.startDate,
        eventContent?.endDate
      );

      setIsEvent(isRegionEligible && inWindow);
    }

    fetchEventWindow();

    return () => {
      isActive = false;
    };
  }, [dispatch]);

  return (
    <Wrapper>
      <EmployerHeroCarousel />
      <EmployerLandingCompanies />
      <EmployerFeaturedMedia />
      <EmployerLandingStatistics />
      {isEvent ? <EmployerHireBetterEvent /> : <EmployerHireBetterNew />}

      <EmployerHeroTagline />
      <EmployerHeroSolution />
      <EmployerLandingAggregator />
      <EmployerLandingWorkCultureReport />
      <EmployHeroBeyondJob />
      <EmployerKnowMore />
      {/* <EmployerHeroVideo /> */}
      <EmployerTestimonial />
      <EmployerInternships />

      {/* Solutions Section */}
      <EmployerLandingPlatform />
      <EmployerLandingContactUs />
      <EmployerLandingViewProductDialog />
      <EmployerLandingContactUsDialog />

      {/* <EmployerLandingTestimonial /> */}
      {/* <EmployerHiredlyStatistics /> */}
      {/* <EmployerLandingSolutions /> */}
      {/* <EmployerLandingProduct /> */}
    </Wrapper>
  );
}

export default EmployerLanding;
